import getAccordion from './accordion';
import getBanner from './banner';
import getButton from './button';
import getButtonGroupElement from './buttonGroupElement';
import getButtonSegment from './buttonSegment';
import getButtonSegmentElement from './buttonSegmentElement';
import getDatePicker from './datePicker';
import getDrawer from './drawer';
import getHorizontalWizard from './horizontalWizard';
import getHorizontalWizardWarnings from './horizontalWizardWarnings';
import getMenu from './menu';
import getTimePicker from './timePicker';
import getTextField from './textField';
import getChip from './chip';
import getExceptionList from './exceptionList';
import getCheckBox from './checkBox';
import getEmptyState from './emptyState';
import getTooltip from './tooltip';
import getTag from './tag';
import getRadioButton from './radioButton';
import getSlider from './slider';
import getBadge from './badge';
import getToast from './toast';
import { getOptionList, getOptionListElement } from './optionList';
import getLink from './link';
import getTableBody from './table/body';
import getTableHeader from './table/header';
import getNavigation from './navigation';
import getBreadCrumbs from './breadCrumbs';
import getModal from './modal';
import getDropzone from './dropzone';
import getTab from './tab';
import getSearch from './search';
import getLoader from './loader';
import getToggle from './toggle';
import getIcon from './icon';
import getWideCheckBox from './wideCheckBox';
import getWizardNavigation from './wizardNavigation';
import getTreeMenu from './treeMenu';
import getMobileNavigation from './mobileNavigation';
import getMobileMenu from './mobileMenu';
import getAsyncSearch from './asyncSearch';
import getGuide from './guide';
import getPopover from './popover';
import getCopyCell from './copyCell';
import getCarousel from './carousel';
import getActionsPopover from './actionsPopover';
import getAvatar from './avatar';
import getButtonGroup from './buttonGroup';
var getFamilies = function (colors) { return ({
    accordion: getAccordion(colors),
    avatar: getAvatar(colors),
    button: getButton(colors),
    buttonGroup: getButtonGroup(colors),
    buttonGroupElement: getButtonGroupElement(colors),
    textField: getTextField(colors),
    checkBox: getCheckBox(colors),
    breadCrumbs: getBreadCrumbs(colors),
    chip: getChip(colors),
    exceptionList: getExceptionList(colors),
    emptyState: getEmptyState(colors),
    datePicker: getDatePicker(colors),
    timePicker: getTimePicker(colors),
    tooltip: getTooltip(colors),
    radioButton: getRadioButton(colors),
    slider: getSlider(colors),
    badge: getBadge(colors),
    optionList: getOptionList(colors),
    optionListElement: getOptionListElement(colors),
    tag: getTag(colors),
    link: getLink(colors),
    toast: getToast(colors),
    tableBody: getTableBody(colors),
    tableHeader: getTableHeader(colors),
    navigation: getNavigation(colors),
    menu: getMenu(colors),
    toggle: getToggle(colors),
    modal: getModal(colors),
    dropzone: getDropzone(colors),
    drawer: getDrawer(colors),
    search: getSearch(colors),
    loader: getLoader(colors),
    tab: getTab(colors),
    icon: getIcon(colors),
    banner: getBanner(colors),
    wideCheckBox: getWideCheckBox(colors),
    wizardNavigation: getWizardNavigation(colors),
    treeMenu: getTreeMenu(colors),
    mobileNavigation: getMobileNavigation(colors),
    mobileMenu: getMobileMenu(colors),
    asyncSearch: getAsyncSearch(colors),
    guide: getGuide(colors),
    popover: getPopover(colors),
    copyCell: getCopyCell(colors),
    carousel: getCarousel(colors),
    actionsPopover: getActionsPopover(colors),
    horizontalWizard: getHorizontalWizard(colors),
    horizontalWizardWarnings: getHorizontalWizardWarnings(colors),
    buttonSegment: getButtonSegment(colors),
    buttonSegmentElement: getButtonSegmentElement(colors),
}); };
export default getFamilies;
export { ThemeFamilies } from './types';
